import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";
const debug = process.env.NODE_ENV !== "production";

const state = {
    lang: "en-US",
    bomeLoading: false,
};

const mutations = {
    updateLang(state, value) {
        state.lang = value;
    },
    updateBomeLoading(state, value) {
        state.bomeLoading = value;
    },
};
const actions = {};

export default createStore({
    state,
    mutations,
    actions,
    strict: debug,
    plugins: [createPersistedState()],
});
